'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cnSkinCore = require('@spp/cn-skin-core');

var _cnSkinCore2 = _interopRequireDefault(_cnSkinCore);

var _logo = require('./svg/logo');

var _logo2 = _interopRequireDefault(_logo);

var _logoShort = require('./svg/logo-short');

var _logoShort2 = _interopRequireDefault(_logoShort);

var _widgets = require('./widgets');

var _widgets2 = _interopRequireDefault(_widgets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-unused-vars */
var chevron = _cnSkinCore2.default.chevron,
    search = _cnSkinCore2.default.search,
    searchClear = _cnSkinCore2.default.searchClear,
    userFilled = _cnSkinCore2.default.userFilled,
    spidLogo = _cnSkinCore2.default.spidLogo,
    userHollow = _cnSkinCore2.default.userHollow,
    userLoggedIn = _cnSkinCore2.default.userLoggedIn;


var LOGIN_BUTTON = 'login';

var LABELS = {
    masthead: {
        search: 'SØK',
        searchPlaceholder: 'Søk',
        menuOpened: 'LUKK',
        menuClosed: 'MENY'
    },
    mastheadExtension: {
        sectionsDropdown: 'kategorier',
        login: 'Logg inn',
        myAccount: 'Min konto',
        mySubscription: 'Min konto',
        subscribe: 'Kjøp VG+'
    },
    userMenu: {
        login: 'Logg inn',
        logout: 'Logg ut',
        myAccount: 'Min konto',
        mySubscription: 'Min konto'
    }
};

var MY_PAGE = {
    name: 'MyPage',
    url: 'https://www.vg.no/minside/'
};

exports.default = {
    id: 'vg',
    name: 'VG',
    publicationId: 'vg',
    perks: {
        host: process.env.PERKS_HOST || 'www.vg.no'
    },
    matrix: {
        version: 'v2',
        host: process.env.MATRIX_HOST || 'matrix.snd.no'
    },
    masthead: {
        labels: {
            search: LABELS.masthead.search,
            searchPlaceholder: LABELS.masthead.searchPlaceholder,
            menuOpened: LABELS.masthead.menuOpened,
            menuClosed: LABELS.masthead.menuClosed
        },
        logoUrl: 'https://www.vg.no/',
        search: {
            url: 'https://www.vg.no/sok/?q={query}'
        },
        svg: {
            logo: _logo2.default,
            search: search,
            searchClear: searchClear,
            userFilled: userFilled,
            userLoggedIn: userLoggedIn
        }
    },
    mastheadExtension: {
        dateLocale: 'nb',
        button: LOGIN_BUTTON,
        labels: {
            sectionsDropdown: LABELS.mastheadExtension.sectionsDropdown,
            login: LABELS.mastheadExtension.login,
            myAccount: LABELS.mastheadExtension.myAccount,
            mySubscription: LABELS.mastheadExtension.mySubscription,
            subscribe: LABELS.mastheadExtension.subscribe
        },
        myPage: MY_PAGE,
        subscribeUrl: 'https://www.vg.no/nyheter/i/jPJ5g9/vg?utm_content=kjopvgpluss&utm_source=vgfront',
        svg: {
            chevron: chevron,
            userFilled: userFilled,
            userLoggedIn: userLoggedIn
        }
    },
    mainMenu: {
        publicationMenu: [{
            name: 'Support',
            url: 'https://support.pluss.vg.no/hc/no/requests/new/'
        }, {
            name: 'Annonseinfo',
            url: 'http://annonseinfo.vg.no/'
        }, {
            name: 'Ledige stillinger',
            url: 'https://vg.jobylon.com/'
        }],
        userMenu: {
            widgets: _widgets2.default,
            labels: {
                login: LABELS.userMenu.login,
                logout: LABELS.userMenu.logout,
                myAccount: LABELS.userMenu.myAccount,
                mySubscription: LABELS.userMenu.mySubscription
            },
            myPage: MY_PAGE,
            subscribe: {
                name: 'Kjøp VG+',
                url: 'https://www.vg.no/nyheter/i/jPJ5g9/vg?utm_content=kjopvgpluss&utm_source=vgfront'
            },
            mySite: {
                name: 'Mine innstillinger',
                url: 'https://www.vg.no/minside/personvern/'
            },
            userMenuWidget: [{
                name: 'Tips oss',
                url: 'https://www.vg.no/tips-oss/'
            }, {
                name: 'Kontakt VG',
                url: 'https://www.vg.no/om-vg/kontakt-oss'
            }, {
                name: 'Hjelp',
                url: 'https://support.pluss.vg.no/hc/no'
            }, {
                name: 'Annonseinfo',
                url: 'http://annonseweb.schibsted.no/en-no/brands/vg-380'
            }, {
                name: 'Ledige stillinger',
                url: 'https://vg.jobylon.com/'
            }]
        },
        svg: {
            chevron: chevron,
            logoShort: _logoShort2.default,
            spidLogo: spidLogo,
            userHollow: userHollow,
            userLoggedIn: userLoggedIn
        }
    },
    importantSections: [{
        key: 'sporten',
        name: 'Sporten',
        url: 'https://www.vg.no/sport/'
    }, {
        key: 'vglive',
        name: 'VG Live',
        url: 'https://www.vglive.no/'
    }, {
        key: 'tvguide',
        name: 'TV-guide',
        url: 'https://tvguide.vg.no/'
    }, {
        key: 'vgpluss',
        name: 'VG+',
        url: 'https://www.vg.no/pluss/'
    }, {
        key: 'tips-oss',
        name: 'Tips oss',
        url: 'https://www.vg.no/tips-oss/'
    }],
    sectionsMenu: [{
        name: 'Nyttige sider',
        mainMenu: true,
        subSections: [{
            name: 'DinePenger',
            url: 'http://www.dinepenger.no/'
        }, {
            name: 'E24',
            url: 'http://e24.no/'
        }, {
            name: 'Familieklubben',
            url: 'https://familieklubben.no/'
        }, {
            name: 'Godt',
            url: 'http://www.godt.no/'
        }, {
            name: 'MinMote',
            url: 'http://www.minmote.no/'
        }, {
            name: 'Pent',
            url: 'https://pent.no/'
        }, {
            name: 'Reise',
            url: 'https://www.vg.no/reise'
        }, {
            name: 'Tek.no',
            url: 'https://www.tek.no/'
        }, {
            name: 'Tipster',
            url: 'https://tipster.no/'
        }, {
            name: 'TV-guide',
            url: 'https://tvguide.vg.no/'
        }, {
            name: 'Vektklubb',
            url: 'https://www.vektklubb.no/'
        }]
    }, {
        path: /nyheter/,
        name: 'Nyheter',
        url: 'https://www.vg.no/nyheter/',
        mainMenu: true,
        subSections: [{
            name: 'Innenriks',
            url: 'https://www.vg.no/nyheter/innenriks/',
            path: '/nyheter/innenriks'
        }, {
            name: 'Utenriks',
            url: 'https://www.vg.no/nyheter/utenriks/',
            path: '/nyheter/utenriks'
        }, {
            name: 'Meninger',
            url: 'https://www.vg.no/nyheter/meninger/',
            path: '/nyheter/meninger'
        }, {
            name: 'Nyhetsdøgnet',
            url: 'https://direkte.vg.no/nyhetsdognet'
        }]
    }, {
        path: /sport/,
        name: 'Sport',
        url: 'https://www.vg.no/sport/',
        mainMenu: true,
        subSections: [{
            name: 'VG Live',
            url: 'https://vglive.no/'
        }, {
            name: 'VG Sporten Direkte',
            url: 'https://direkte.vg.no/studio/vgsporten'
        }, {
            name: 'Vintersport Direkte',
            url: 'https://www.vg.no/spesial/2019/ski/'
        }, {
            name: 'Alpint',
            url: 'https://www.vg.no/sport/alpint/',
            path: '/sport/alpint'
        }, {
            name: 'Fotball',
            url: 'https://www.vg.no/sport/fotball/',
            path: '/sport/fotball'
        }, {
            name: 'Friidrett',
            url: 'https://www.vg.no/sport/friidrett/',
            path: '/sport/friidrett'
        }, {
            name: 'Hopp',
            url: 'https://www.vg.no/sport/hopp/',
            path: '/sport/hopp'
        }, {
            name: 'Håndball',
            url: 'https://www.vg.no/sport/haandball/',
            path: '/sport/haandball'
        }, {
            name: 'Ishockey',
            url: 'https://www.vg.no/sport/ishockey/',
            path: '/sport/ishockey'
        }, {
            name: 'Kampsport',
            url: 'https://www.vg.no/sport/kampsport/',
            path: '/sport/kampsport'
        }, {
            name: 'Langrenn',
            url: 'https://www.vg.no/sport/langrenn/',
            path: '/sport/langrenn'
        }, {
            name: 'Motorsport',
            url: 'https://www.vg.no/sport/motorsport/',
            path: '/sport/motorsport'
        }, {
            name: 'Skiskyting',
            url: 'https://www.vg.no/sport/skiskyting/',
            path: '/sport/skiskyting'
        }, {
            name: 'Sykkel',
            url: 'https://www.vg.no/sport/sykkel/',
            path: '/sport/sykkel'
        }]
    }, {
        path: /rampelys/,
        name: 'Rampelys',
        url: 'https://www.vg.no/rampelys/',
        mainMenu: true,
        subSections: [{
            name: 'Bok',
            url: 'https://www.vg.no/rampelys/bok/',
            path: '/rampelys/bok'
        }, {
            name: 'Film',
            url: 'https://www.vg.no/rampelys/film/',
            path: '/rampelys/film'
        }, {
            name: 'Musikk',
            url: 'https://www.vg.no/rampelys/musikk/',
            path: '/rampelys/musikk'
        }, {
            name: 'Spill',
            url: 'https://www.vg.no/rampelys/spill/',
            path: '/rampelys/spill'
        }, {
            name: 'TV',
            url: 'https://www.vg.no/rampelys/tv/',
            path: '/rampelys/tv'
        }, {
            name: 'Panelet',
            url: 'https://www.vgtv.no/kategori/100065/panelet'
        }]
    }, {
        path: /forbruker/,
        name: 'Forbruker',
        url: 'https://www.vg.no/forbruker/',
        mainMenu: true,
        subSections: [{
            name: 'Bil, båt og motor',
            url: 'https://www.vg.no/forbruker/bil-baat-og-motor/',
            path: '/forbruker/bil-baat-og-motor'
        }, {
            name: 'Helse',
            url: 'https://www.vg.no/forbruker/helse/',
            path: '/forbruker/helse'
        }, {
            name: 'Livsstil',
            url: 'https://www.vg.no/forbruker/livsstil/',
            path: '/forbruker/livsstil'
        }, {
            name: 'Mat og drikke',
            url: 'https://www.vg.no/forbruker/mat-og-drikke/',
            path: '/forbruker/mat-og-drikke'
        }, {
            name: 'Teknologi',
            url: 'https://www.vg.no/forbruker/teknologi/',
            path: '/forbruker/teknologi'
        }, {
            name: 'Forbrukslån',
            url: 'https://www.vg.no/sammenlign/forbrukslån/',
            path: '/sammenlign/forbrukslån'
        }]
    }, {
        path: '/pluss',
        name: 'VG+',
        url: 'https://www.vg.no/pluss',
        mainMenu: true,
        subSections: [{
            name: 'Siste saker',
            url: 'https://www.vg.no/pluss'
        }, {
            name: 'Dokumentarer',
            url: 'https://www.vgtv.no/vgpluss-dokumentar'
        }]
    }, {
        name: 'Annet',
        mainMenu: true,
        subSections: [{
            name: 'E-avis',
            url: 'https://kundeweb.vg.no/s/ff/products/1893/'
        }, {
            name: 'Podkast',
            url: 'https://www.vg.no/podkast'
        }, {
            name: 'Trav',
            url: 'http://trav.vg.no/'
        }, {
            name: 'Tegneserier',
            url: 'https://www.vg.no/tegneserier'
        }, {
            name: 'Valgomat 2019',
            url: 'https://www.vg.no/spesial/2019/valgomat/'
        }, {
            name: 'VG Debatt',
            url: 'http://vgd.no/'
        }, {
            name: 'VG Helgeabonnement',
            url: 'https://hjem.vg.no/'
        }, {
            name: 'VG-lista',
            url: 'http://vglista.no/'
        }, {
            name: 'VGTV',
            url: 'http://www.vgtv.no/'
        }]
    }, {
        name: 'Andre tjenester',
        mainMenu: true,
        subSections: [{
            name: 'Partnerstudio',
            url: 'http://vgpartnerstudio.no/'
        }, {
            name: 'Rabattkode',
            url: 'https://www.vg.no/rabattkode/'
        }, {
            name: 'Mitt anbud',
            url: 'https://mittanbud.no/'
        }, {
            name: 'Navnelapper',
            url: 'https://smartlapper.no/navnelapper/'
        }, {
            name: 'Black Friday',
            url: 'https://www.vg.no/black-friday'
        }, {
            name: 'Bilguiden',
            url: 'https://www.vg.no/bil/'
        }, {
            name: 'Strømguiden',
            url: 'https://www.vg.no/sammenlign/str%C3%B8m'
        }]
    }, {
        path: /tegneserier/,
        name: 'Tegneserier',
        url: 'https://www.vg.no/tegneserier',
        mainMenu: false,
        subSections: [{
            name: 'Pondus',
            url: 'https://www.vg.no/tegneserier#comic-pondus',
            path: '/tegneserier#comic-pondus'
        }, {
            name: 'Lunch',
            url: 'https://www.vg.no/tegneserier#comic-lunch',
            path: '/tegneserier#comic-lunch'
        }, {
            name: 'Hjalmar',
            url: 'https://www.vg.no/tegneserier#comic-hjalmar',
            path: '/tegneserier#comic-hjalmar'
        }, {
            name: 'Kald Kaffe',
            url: 'https://www.vg.no/tegneserier#comic-kald-kaffe',
            path: '/tegneserier#comic-kald-kaffe'
        }, {
            name: 'Tegnehanne',
            url: 'https://www.vg.no/tegneserier#comic-tegnehanne',
            path: '/tegneserier#comic-tegnehanne'
        }]
    }]
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/lib/cjs/index.js
 ** module id = 309
 ** module chunks = 1
 **/